import React, { useState, useEffect, useContext, useRef} from 'react';
import * as S from './styles';
import { Context } from '../../services/contexts/StateContext';
import { descricaoParaTexto } from '../../services/descricaoEventoUtil';
import api from '../../services/api';
import { format, addDays } from 'date-fns';
//---------COMPONENTES----------------------
import { ExibirArquivosS3ListaVistoria } from '../../componentes/Cadastro/ExibirArquivosS3ListaVistoria';
import delet from '../../midia/delete.svg';

//---------SERVICES--------------------------
import { Api_Clientes } from '../../services/FiltrosApi/clienteApi';
import { Api_Veiculos } from '../../services/FiltrosApi/veiculos_api';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';
import deleteAzul from '../../midia/delete_azul.svg';
import concluido from '../../midia/concluido.svg';
// ------------------------------------------
export function ListaVistoria() {
    const { state, dispatch } = useContext(Context);
    const { cliente, usuario, logado } = state.cliente;
    const { veiculo } = state.veiculo;
    const { evento } = state.evento;

    const { parametroInit, listaPesquisa, playLista } = state.parametros;
    const {
        pesquisaIdVeiculo,
        pesquisaIdUsuario,
    } = parametroInit;

    const { id_Usuario } = usuario;
    const { id_Veiculo } = veiculo;
    const { id_Evento, codEvenBD } = evento;
    const { listaEvento } = listaPesquisa;

    const [idPag, setIdPag] = useState('');
    const [Statusconcluido, setCCConcluido] = useState('');
    const [valor_pago, setvalor_pago] = useState('');
    const [somaValorPago, setSomaValorPago] = useState('')
    const [valorPendente, setValorPend] = useState('');
    const [checkEven, setcheckEven] = useState(false);
    const [checkPag, setcheckPag] = useState(false);
    const [newValor_produtos, editValorProdutos] = useState('');
    const [newValor_servico, editValorServicos] = useState('');
    const [TotalEven, setTotalEven] = useState('');
    const [listaPag, setListaPag] = useState([]);

    const [alertDelete, setAletDelete] = useState(false);
    const [newStatus, setNewStatus] = useState('');
    const [refDelete, setRefDelet] = useState('');
    const [tipoEventoVistoria, setTipoEventoVistoria] = useState('');
    const [loadingTipoEvento, setLoadingTipoEvento] = useState(false);
    const [eventoSelecionadoDetalhe, setEventoSelecionadoDetalhe] = useState(null);
    const [modoDetalheSelecionado, setModoDetalheSelecionado] = useState(false);
    const [cotacoes, setCotacoes] = useState([]);
    const [buscandoCotacoes, setBuscandoCotacoes] = useState(false);
    const buscaTipoVistoriaId = useRef(0);

    const { pesqIDveiculo, pesqTodasCotacoes } = Api_Veiculos();
    const { pesqidcliente } = Api_Clientes();
    const { PesqEventoCod } = ApiEvento();

    const dataAtual = new Date();

    async function BuscarCotacoes() {
        setBuscandoCotacoes(true);
        try {
            const registros = await pesqTodasCotacoes();
            if (Array.isArray(registros)) {
                setCotacoes(registros);
            }
        } finally {
            setBuscandoCotacoes(false);
        }
    }

    async function ConcluirCotacao(cotacao) {
        try {
            await api.put(`veiculo/upRegistro/${cotacao.id_Cotacao}`, {
                id_Registros: cotacao._id,
                status: 'C',
            });
            setCotacoes(atual => atual.map(item =>
                item._id === cotacao._id && item.id_Cotacao === cotacao.id_Cotacao
                    ? { ...item, status: 'C' }
                    : item
            ));
        } catch (error) {
            alert(`Erro ao concluir cotacao: ${error.response?.data?.message || error.message}`);
        }
    }

    async function ExcluirCotacao(cotacao) {
        if (!window.confirm('Deseja excluir definitivamente esta cotacao?')) {
            return;
        }

        try {
            await api.delete(`veiculo/cotacao/${cotacao.id_Cotacao}/registro/${cotacao._id}`);
            setCotacoes(atual => atual.filter(item =>
                item._id !== cotacao._id || item.id_Cotacao !== cotacao.id_Cotacao
            ));
        } catch (error) {
            alert(`Erro ao excluir cotacao: ${error.response?.data?.message || error.message}`);
        }
    }

    useEffect(() => {
        BuscarCotacoes();
    }, []);

    function SelecionarTipoVistoria(tipo) {
        const requestId = ++buscaTipoVistoriaId.current;
        setTipoEventoVistoria(tipo);
        setLoadingTipoEvento(false);
        setModoDetalheSelecionado(false);
        setEventoSelecionadoDetalhe(null);
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { ...listaPesquisa, listaEvento: [] }
        });
        if (!tipo) {
            dispatch({
                type: 'SET_parametroInit',
                payload: { ...parametroInit, loading: false }
            });
        }
        if (tipo) {
            BuscarTipoVistoria(tipo, requestId);
        }
    }

    //-----------------------------------------------
    useEffect(() => {
        if (pesquisaIdVeiculo) {
            pesqIDveiculo();
        }
    }, [pesquisaIdVeiculo])


    // -------------------
    useEffect(() => {
        if (pesquisaIdUsuario) {
            pesqIdUsuario();
        }
    }, [pesquisaIdUsuario])

    //--Pesquisar Usuario por id----------------------------
    async function pesqIdUsuario() {
        if (id_Usuario) {
            await api.get(`/usuario/id/${id_Usuario}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaUsuario: [res.data] }
                    });
                    dispatch({
                        type: 'set_playLista',
                        payload: { ...playLista, playListaUsuario: true }
                    });
                    dispatch({
                        type: 'SET_parametroInit',
                        payload: { ...parametroInit, pesquisaIdUsuario: false }
                    });

                })
        }
    };

    //----Pesquisar Evento por Veiculo---------------
    async function pesqEventoXveiculo() {
        if (id_Veiculo) {
            await api.get(`/evento/idveiculo/${id_Veiculo}`)
                .then(res => {
                    dispatch({
                        type: 'set_ListaPesquisa',
                        payload: { ...listaPesquisa, listaEvento: res.data }
                    });
                })
        }
    };

    //---Buscar no banco apenas por tipoEvento (vistoria_evento | vistoria_cadastro)
    //---e trazer somente registros com status diferente de "E".
    async function BuscarTipoVistoria(tipo, requestId) {
        if (!tipo) {
            return;
        }

        dispatch({
            type: 'SET_parametroInit',
            payload: { ...parametroInit, loading: true, detalhesLista: false }
        });
        setModoDetalheSelecionado(false);
        setEventoSelecionadoDetalhe(null);
        dispatch({
            type: 'set_ListaPesquisa',
            payload: { ...listaPesquisa, listaEvento: [] }
        });
        setLoadingTipoEvento(true);

        try {
            const res = await api.post('/evento/Tudo/Tipo', {
                placa: '',
                tipo,
                user: logado.idLogado,
                Tudo: true,
            });
            if (requestId !== buscaTipoVistoriaId.current) {
                return;
            }
            if (!Array.isArray(res.data)) {
                throw new Error('A resposta da busca de eventos não é uma lista válida.');
            }

            const eventosFiltrados = res.data.filter(
                evento => evento?.tipoEvento === tipo
            );

            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    listaEvento: eventosFiltrados,
                }
            });

            dispatch({
                type: 'set_playLista',
                payload: { ...playLista, playListaEven: true }
            });
        } catch (error) {
            if (requestId === buscaTipoVistoriaId.current) {
                alert('Ocorreu um erro ao buscar os eventos de vistoria por tipo.');
            }
        } finally {
            if (requestId === buscaTipoVistoriaId.current) {
                dispatch({
                    type: 'SET_parametroInit',
                    payload: { ...parametroInit, loading: false }
                });
                setLoadingTipoEvento(false);
            }
        }
    };

    //---Pesquisar Pag por Id evento----------------------------
    async function pesqPagXevento() {
        if (id_Evento) {
            await api.get(`paguevento/idevento/${id_Evento}`)
                .then(res => {
                    setListaPag(res.data);

                    const busc = res.data
                    //-----------Soma Valores Pagos-----------------------
                    const restbusc = busc.map(t => t.valor_pago);
                    let soma = 0;
                    for (let i = 0; i < restbusc.length; i++) {
                        soma += restbusc[i]
                    }
                    setSomaValorPago(soma)

                });
        }
    };

    //-Atualizar Evento - Colocar como Pago "Statusconcluido" ou Aberto---------
    async function AtualizarConcluido() {
        if (somaValorPago >= TotalEven && Statusconcluido === false) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: true,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Pago!');
                }
            })
        };
        //--------
        if (somaValorPago < TotalEven && Statusconcluido === true) {
            await api.put(`/evento/atualizar/${id_Evento}`, {
                Statusconcluido: false,
                data_modificado: Date.now(),

            }).then(res => {
                if (res.data.error) {
                    alert('erro')
                } else {
                    alert('Evento Esta em Abeto!');
                }
            })
        };
    };

    //------------------------------------
    useEffect(() => {
        AtualizarConcluido()
    }, [somaValorPago && TotalEven && Statusconcluido])

    //----Valores Falta Pagar Pendente----
    useEffect(() => {
        setValorPend(TotalEven - somaValorPago)
    }, [valor_pago, newValor_servico, newValor_produtos, somaValorPago])

    //---Pesquisar Pag por id pag----------
    async function PesqIdPag() {
        if (idPag) {
            await api.get(`/paguevento/${idPag}`)
                .then(res => {

                    setListaPag([res.data]);
                });
        }
    };

    // ------------------------------
    useEffect(() => {
        pesqidcliente();
    }, [cliente.id_Cliente]);

    //--------------------------------
    useEffect(() => {
        if (checkEven) {
            if (!checkPag) {
                pesqPagXevento(); // pesquisar todos os pagamento deste evento
            }
        }
        if (!checkEven) {
            setcheckPag(false);
            setIdPag();
            setListaPag([])
        }
    }, [checkEven])

    // ---------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
                playModalDetalhesEven: false,
            }
        });
    }, [parametroInit.filtroPlaca])

    //---------------------------------
    useEffect(() => {
        if (checkPag) {
            PesqIdPag() // pesquisar id do pagamento
            setcheckPag(idPag) //selecionar o id pesquisado
        }
    }, [idPag])

    //---Se checkEven for desselecionado fazer pesquisa de todos eventos----
    useEffect(() => {
        if (!checkEven)
            pesqEventoXveiculo();
    }, [checkEven])

    //---Se checkPag for desselecionado fazer pesquisa de todos Pagamentos----
    useEffect(() => {
        if (!checkPag)
            pesqPagXevento();
    }, [checkPag])

    //-------------------Gerar Codigos-----------
    useEffect(() => {
        let inic = (1);
        let codinic = veiculo.placa + '-0' + inic;
        const regex = new RegExp(codinic, 'i'); // Expresao regular
        let verific = regex.test(codEvenBD) // verificar se ja existe este codigo no banco de dados
        //--------
        if (verific) { // se cod for igual, gerar novo
            for (; verific; inic++) {
                let codNovo = veiculo.placa + '-0' + inic
                const regex = new RegExp(codNovo, 'i');
                let verific = regex.test(codEvenBD)

                if (!verific) {
                    dispatch({
                        type: 'set_Evento',
                        payload: { ...evento, codEvento: codNovo }
                    });
                    break
                }
            };
        } else {
            if (veiculo.placa) {
                dispatch({
                    type: 'set_Evento',
                    payload: { ...evento, codEvento: codinic }
                });
            }
        }
    }, [codEvenBD && veiculo.placa]);

    useEffect(() => {
        if (listaEvento && listaEvento.length > 0) {
            setEventoSelecionadoDetalhe(listaEvento[0]);
            setModoDetalheSelecionado(false);
        } else {
            setEventoSelecionadoDetalhe(null);
            setModoDetalheSelecionado(false);
        }
    }, [listaEvento])

    function AbrirDetalheEventoSelecionado(item) {
        setEventoSelecionadoDetalhe(item);
        setModoDetalheSelecionado(true);
    }

    function VoltarParaListaEventos() {
        setModoDetalheSelecionado(false);
        setEventoSelecionadoDetalhe(null);
    }

    function lixeira(item) {
        dispatch({
            type: 'set_Evento',
            payload: { ...evento, id_Evento: item?._id }
        });

        setNewStatus('E');
        setRefDelet('evento');
    }

    async function ExcluirEsteEventoSelecionado(item) {
        const idParaExcluir = item?._id || evento?.id_Evento;

        if (!idParaExcluir) {
            return;
        }

        const confirmar = window.confirm('Deseja mesmo excluir este evento?');
        if (!confirmar) {
            return;
        }

        await api.put(`evento/atualizarSimples/${idParaExcluir}`, {
            status: 'E',
            logs: {
                idUsuario: logado.id_Cliente,
                acao: 'excluir evento',
                plataforma: "interno",
                localizacao: {
                    latitude: veiculo.latitude ? veiculo.latitude : null,
                    longitude: veiculo.longitude ? veiculo.longitude : null,
                }
            }
        });

        const listaAtualizada = (listaPesquisa.listaEvento || []).filter(ev => ev?._id !== idParaExcluir);

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                listaEvento: listaAtualizada,
            }
        });

        setModoDetalheSelecionado(false);
        setEventoSelecionadoDetalhe(null);
    }
    // ----------------------------------

    useEffect(() => {
    //   Filtrar Lista Evento por userCadastro
        if (listaPesquisa.id_nomeUser) {
            const eventosUser = listaPesquisa.listaEvento.filter(ev => ev.userCadastro?._id === listaPesquisa.id_nomeUser);
            dispatch({
                type: 'set_ListaPesquisa',
                payload: { ...listaPesquisa, listaEvento: eventosUser }
            });
        }
    }, [listaPesquisa.id_nomeUser])

    //-------------------------------


    //###################################################################################################
    return (
        <>
        <S.ContainerLista>
            <S.containerPesq>

                <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '8px', flexWrap: 'wrap' }}>
                    <select
                        value={tipoEventoVistoria}
                        onChange={(e) => SelecionarTipoVistoria(e.target.value)}
                        style={{ minWidth: '210px', height: '34px', borderRadius: '4px', border: '1px solid #ccc', padding: '0 8px' }}
                    >
                        <option value="">Tipo vistoria</option>
                        <option value="vistoria_evento">Evento</option>
                        <option value="vistoria_cadastro">Cadastro</option>
                    </select>

                </div>

                {!tipoEventoVistoria && (
                <div style={{
                    display: 'flex',
                    flex: 1,
                    minHeight: 0,
                    flexDirection: 'column',
                    marginTop: '14px',
                    borderRadius: '12px',
                    border: '1px solid #d6e3f0',
                    background: 'linear-gradient(180deg, #f8fbff 0%, #edf4fb 100%)',
                    padding: '12px',
                    boxShadow: '0 12px 28px rgba(21, 53, 85, 0.10)',
                    color: '#1d2a23'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
                        <div style={{ fontWeight: 700, color: '#173c5c' }}>Cotações</div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span style={{ fontSize: '12px', color: '#31556f', background: '#deedf9', borderRadius: '999px', padding: '4px 10px' }}>
                                {cotacoes.length} registro(s)
                            </span>
                            <button
                                type='button'
                                onClick={BuscarCotacoes}
                                disabled={buscandoCotacoes}
                                style={{
                                    borderRadius: '6px',
                                    padding: '6px 10px',
                                    background: buscandoCotacoes ? '#bdbdbd' : '#1d6f9e',
                                    color: '#fff',
                                    fontWeight: 600,
                                }}
                            >
                                {buscandoCotacoes ? 'Buscando...' : 'Atualizar'}
                            </button>
                        </div>
                    </div>

                    {/* Cotacoes Lista ------------ */}
                    {cotacoes.length > 0 ? (
                        <div style={{
                            display: 'flex',
                            flex: 1,
                            minHeight: 0,
                            flexDirection: 'column',
                            overflow: 'auto',
                        }}>
                            <div style={{
                                display: 'flex',
                                flex: 1,
                                minHeight: 0,
                                minWidth: '1080px',
                                flexDirection: 'column',
                            }}>
                                <div style={{
                                    display: 'grid',
                                    flexShrink: 0,
                                    gridTemplateColumns: '90px 110px 140px 90px 110px 110px 140px 100px minmax(100px, 1fr)',
                                    gap: '8px',
                                    padding: '7px 10px',
                                    color: '#31556f',
                                    fontSize: '12px',
                                    fontWeight: 700,
                                }}>
                                    <span>Placa</span>
                                    <span>Modelo</span>
                                    <span>Franquia</span>
                                    <span>Data</span>
                                    <span>Adesão</span>
                                    <span>Mensal</span>
                                    <span>WhatsApp</span>
                                    <span>Status</span>
                                    <span style={{ textAlign: 'right' }}>Ações</span>
                                </div>
                                <ul style={{ flex: 1, minHeight: 0, margin: 0, padding: 0, listStyle: 'none', overflowY: 'auto' }}>
                                    {cotacoes.map((cotacao, index) => (
                                        <li
                                            key={`${cotacao.id_Cotacao}-${cotacao._id || index}`}
                                            style={{
                                                display: 'grid',
                                                gridTemplateColumns: '90px 110px 140px 90px 110px 110px 140px 100px minmax(100px, 1fr)',
                                                alignItems: 'center',
                                                gap: '8px',
                                                marginBottom: '5px',
                                                padding: '9px 10px',
                                                border: '1px solid #d6e3f0',
                                                borderRadius: '8px',
                                                background: cotacao.status === 'C' ? '#e5f6eb' : '#fff',
                                                whiteSpace: 'nowrap',
                                                fontSize: '12px',
                                            }}
                                        >
                                            <span>{cotacao.placa || cotacao.id_Veiculo?.placa || '-'}</span>
                                            <span>{cotacao.id_Veiculo?.modelo?.trim().split(/\s+/)[0] || '-'}</span>
                                            <span>{cotacao.id_Franquia?.nome || 'VISTORIA'}</span>
                                            <span>{cotacao.data ? new Date(cotacao.data).toLocaleDateString('pt-BR') : '-'}</span>
                                            <span>R$ {Number(cotacao.valorAdesao || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                                            <span>R$ {Number(cotacao.valorCotacao || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}</span>
                                            <span>{cotacao.whatsapp || '-'}</span>
                                            <span>{cotacao.status === 'C' ? 'Concluída' : 'Pendente'}</span>
                                            <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: '10px' }}>
                                                {cotacao.status !== 'C' && (
                                                    <img
                                                        src={concluido}
                                                        alt='Concluir cotacao'
                                                        title='Marcar como concluida'
                                                        onClick={() => ConcluirCotacao(cotacao)}
                                                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                                    />
                                                )}
                                                <img
                                                    src={deleteAzul}
                                                    alt='Excluir cotacao definitivamente'
                                                    title='Excluir definitivamente'
                                                    onClick={() => ExcluirCotacao(cotacao)}
                                                    style={{ width: '18px', height: '20px', cursor: 'pointer' }}
                                                />
                                            </span>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    ) : (
                        <div style={{ fontSize: '13px', color: '#526b7c' }}>
                            {buscandoCotacoes ? 'Buscando cotações...' : 'Nenhuma cotação encontrada.'}
                        </div>
                    )}
                </div>
                )}

                {/* EVENTO - Lista de eventos */}
                {(tipoEventoVistoria || loadingTipoEvento || listaEvento?.length > 0) && (
                    <div style={{
                        display: 'flex',
                        flex: 1,
                        minHeight: 0,
                        flexDirection: 'column',
                        marginTop: '14px',
                        borderRadius: '12px',
                        border: '1px solid #d6e3f0',
                        background: 'linear-gradient(180deg, #f8fbff 0%, #edf4fb 100%)',
                        padding: '12px',
                        boxShadow: '0 12px 28px rgba(21, 53, 85, 0.10)',
                        color: '#1d2a23'
                    }}>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px', flexWrap: 'wrap', gap: '8px' }}>
                            <div style={{ fontWeight: 700, color: '#173c5c' }}>Eventos da busca</div>
                            <div style={{ fontSize: '12px', color: '#31556f', background: '#deedf9', borderRadius: '999px', padding: '4px 10px' }}>
                                {listaEvento.length} registro(s)
                            </div>
                        </div>

                        {!modoDetalheSelecionado && listaEvento.length > 0 &&
                        <div style={{ display: 'flex', flex: 1, minHeight: 0, flexDirection: 'column', overflow: 'auto' }}>
                        <div style={{ display: 'flex', flex: 1, minHeight: 0, minWidth: '720px', flexDirection: 'column' }}>
                        <div style={{
                            display: 'grid',
                            flexShrink: 0,
                            gridTemplateColumns: 'minmax(130px, 1.2fr) 110px minmax(150px, 1.3fr) 110px 100px',
                            gap: '8px',
                            padding: '7px 10px',
                            color: '#31556f',
                            fontSize: '12px',
                            fontWeight: 700,
                        }}>
                            <span>Código</span>
                            <span>Placa</span>
                            <span>Tipo</span>
                            <span>Data</span>
                            <span>Status</span>
                        </div>
                        <ul style={{ flex: 1, minHeight: 0, margin: 0, padding: 0, listStyle: 'none', overflowY: 'auto' }}>
                            {listaEvento.map((item, index) => {
                                const idItem = item?._id || item?.id_Evento || index;
                                const selecionado = eventoSelecionadoDetalhe?._id === item?._id;

                                return (
                                    <li key={idItem} style={{ marginBottom: '5px' }}>
                                        <button
                                            type='button'
                                            onClick={() => AbrirDetalheEventoSelecionado(item)}
                                            style={{
                                                width: '100%',
                                                display: 'grid',
                                                gridTemplateColumns: 'minmax(130px, 1.2fr) 110px minmax(150px, 1.3fr) 110px 100px',
                                                alignItems: 'center',
                                                gap: '8px',
                                                textAlign: 'left',
                                                background: selecionado ? '#deedf9' : '#fff',
                                                border: selecionado ? '1px solid #1d6f9e' : '1px solid #d6e3f0',
                                                borderRadius: '8px',
                                                padding: '9px 10px',
                                                color: '#1d2a23',
                                                whiteSpace: 'nowrap',
                                                fontSize: '12px',
                                            }}
                                        >
                                            <span>{item?.codEvento || '-'}</span>
                                            <span>{item?.placa || '-'}</span>
                                            <span>{item?.tipoEvento || '-'}</span>
                                            <span>{item?.dataEvento ? format(new Date(item.dataEvento), 'dd/MM/yyyy') : '-'}</span>
                                            <span>{item?.status || '-'}</span>
                                        </button>
                                    </li>
                                );
                            })}
                        </ul>
                        </div>
                        </div>
                        }

                        {!modoDetalheSelecionado && listaEvento.length === 0 && (
                            <div style={{ fontSize: '13px', color: '#526b7c' }}>
                                {loadingTipoEvento ? 'Buscando eventos...' : 'Nenhum evento encontrado.'}
                            </div>
                        )}

                    {/* EVENTO - Mostrar DETALHES */}
                        {modoDetalheSelecionado && eventoSelecionadoDetalhe && (
                            <div style={{
                                marginTop: '12px',
                                background: '#ffffff',
                                border: '1px solid #d6e6dc',
                                borderRadius: '10px',
                                padding: '12px',
                                color: '#1a2b23',
                                lineHeight: 1.35
                            }}>
                                <div style={{ fontWeight: 800, color: '#0f3e28', marginBottom: '10px' }}>
                                    Detalhes do evento selecionado
                                </div>

                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                                    <img
                                        src={delet}
                                        alt='Excluir evento'
                                        title='Excluir evento'
                                        onClick={() => {
                                            lixeira(eventoSelecionadoDetalhe);
                                            ExcluirEsteEventoSelecionado(eventoSelecionadoDetalhe);
                                        }}
                                        style={{ width: '20px', height: '20px', cursor: 'pointer' }}
                                    />

                                    <button
                                        type='button'
                                        onClick={VoltarParaListaEventos}
                                        style={{
                                            background: '#1f6e47',
                                            color: '#ffffff',
                                            border: 'none',
                                            borderRadius: '6px',
                                            padding: '7px 12px',
                                            fontWeight: 700,
                                            cursor: 'pointer'
                                        }}
                                    >
                                        Voltar para lista
                                    </button>
                                </div>

                                <div style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
                                    gap: '8px',
                                    marginBottom: '12px'
                                }}>
                                    <div><strong>Código:</strong> {eventoSelecionadoDetalhe?.codEvento || '-'}</div>
                                    <div><strong>Placa:</strong> {eventoSelecionadoDetalhe?.placa || '-'}</div>
                                    <div><strong>Tipo Evento:</strong> {eventoSelecionadoDetalhe?.tipoEvento || '-'}</div>
                                    <div><strong>Status:</strong> {eventoSelecionadoDetalhe?.status || '-'}</div>
                                    <div><strong>Orçamento:</strong> {eventoSelecionadoDetalhe?.orcamento || 0}</div>
                                    <div><strong>Data Evento:</strong> {eventoSelecionadoDetalhe?.dataEvento ? new Date(eventoSelecionadoDetalhe.dataEvento).toLocaleDateString('pt-BR') : '-'}</div>
                                    <div><strong>Fornecedor:</strong> {eventoSelecionadoDetalhe?.id_Fornecedor?.nome || '-'}</div>
                                    <div><strong>Usuário Cadastro:</strong> {eventoSelecionadoDetalhe?.userCadastro?.nome || '-'}</div>
                                </div>

                                <div style={{ marginBottom: '8px' }}>
                                    <strong>Descrição:</strong> {descricaoParaTexto(eventoSelecionadoDetalhe?.descricao) || '-'}
                                </div>

                                <div style={{ marginBottom: '8px' }}>
                                    <strong>Narração:</strong> {eventoSelecionadoDetalhe?.narracao || '-'}
                                </div>

                                <ExibirArquivosS3ListaVistoria arqVistoria={eventoSelecionadoDetalhe?.arquivos || []} />
                            </div>
                        )}
                    </div>
                )}
            </S.containerPesq>
        </S.ContainerLista>
            
        </>
    )
}